var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary width--100per",class:_vm.containerClass,attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.redirectToInvites()}}},[_c('i',{staticClass:"fa fa-plus t-sm pr-2 t-white-darker"}),_vm._v(_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }